



















































































import { Component, Prop, Watch, Vue } from 'vue-property-decorator'

// Model
import BeaconModel from '@/_models/BeaconModel'

// Components
import EditModalLayout from '@/components/common/modals/EditModalLayout.vue'

@Component({
  components: { EditModalLayout },
})
export default class BeaconCarriedListEditModal extends Vue {
  @Prop()
  isOpen!: boolean

  @Prop()
  isNew!: boolean

  @Prop()
  labelBeaconUUID!: string

  @Prop({ default: [] })
  filteredDataBeaconUUID!: BeaconModel[]

  @Prop()
  data!: any

  formData: any = {}
  filterData: BeaconModel[] = []

  @Watch('formData')
  updateData() {
    this.$emit('update:data', this.formData)
  }

  beforeUpdate() {
    this.formData = { ...this.data }
    this.filterData = [...this.filteredDataBeaconUUID]
  }
}
